/// \file securityLogs.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2024 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const SecurityLogsList = lazy(() => import('../views/security-logs/list/view'));

async function securityLogsDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/security-logs/list/loader')).default;
  return actualLoader(args);
}

export async function securityLogsAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/security-logs/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="securityLogs"
    handle={{
      text: 'Security Logs'
      }}
  >
    <Route 
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <SecurityLogsList />
        </Suspense>
      }     
      loader={securityLogsDataLoader}
      action={securityLogsAction}
      />
  </Route>
);

export default routes;